import gsap from "gsap";
import Flip from "gsap/Flip";
import ScrollTrigger from "gsap/ScrollTrigger";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";
import MotionPathPlugin from "gsap/MotionPathPlugin";

gsap.registerPlugin(Flip,ScrollTrigger,DrawSVGPlugin,MorphSVGPlugin, MotionPathPlugin);


import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupA11yPlugin from '@swup/a11y-plugin';
import SwupGtmPlugin from '@swup/gtm-plugin';


import { preloadImages, scrollToContent, isTouchDevice, toggleClassOnElement, debounce, horizontalLoop  } from './components/utils';
import lazySizes from 'lazysizes';
import fitvids from 'fitvids'

// Push the initial page view to the dataLayer for GTM
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
    event: 'VirtualPageview',
    virtualPageURL: window.location.pathname + window.location.search,
    virtualPageTitle: document.title,
});

import Headroom from "headroom.js";
function initHeadroom() {
    var headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
    var numericValue = parseInt(headerHeight, 10);
    // console.log(headerHeight);
    // console.log(numericValue);
    var myElement = document.querySelector("body");
    var options = {
        offset: numericValue,
    };
    var headroom = new Headroom(myElement, options);
    headroom.init();
}



import { initSliders } from './components/sliders';
import { initMobileMenu } from './components/mobile-menu';
import { initMobileSubMenu } from './components/mobile-submenu';
import { initSubMenu } from './components/sub-menu';
import { initAccordion } from './components/accordion';
import { initAnimations } from './components/animations';
import { initTeam } from './components/team-map';

 initMobileSubMenu();


function toggleFunctions() {
    toggleClassOnElement('#read-more-melissa', '#more-melissa', 'not-hidden', 'active', true);
    toggleClassOnElement('#more-team', '#team-map', 'show-all', 'hide', false);
};



const swup = new Swup({
    containers: ['#swup','.header'],
    plugins: [
        new SwupPreloadPlugin(),
        new SwupBodyClassPlugin(),
        new SwupA11yPlugin(),
        new SwupGtmPlugin()
    ]
});



swup.hooks.replace('animation:out:await', async () => {
  await gsap.to('.transition-fade', { opacity: 0, duration: 0.25, y:6, ease: "power3.inOut" });
});
preloadImages().then(() => {
    swup.hooks.replace('animation:in:await', async () => {
      await gsap.fromTo('.transition-fade', { opacity: 0 }, { opacity: 1, duration: 0.25, ease: "power3.inOut" });
    });
});




// Define the photo scroller web component
class PhotoScroller extends HTMLElement {

    connectedCallback() {
        // Create the container element
        const container = document.createElement('div');
        container.classList.add('photo-scroller');

        // Move the initial images provided within the component tags into the container
        const initialImages = this.innerHTML;
        container.innerHTML = initialImages;
        this.innerHTML = '';

        // Append the container to the web component
        this.appendChild(container);

        // Select all img elements within the container
        const images = container.querySelectorAll('.team-map__member');

        // Call the animate method to start the scrolling animation on the img elements
        this.animateScroll(images);

        // Select all team member inner elements
        const teamMembers = container.querySelectorAll(".team-map__member-inner");

        if (!isTouchDevice()) {
            teamMembers.forEach(member => {
                const tease = member.querySelector('.team-map__member-tease');

                // Mouse enter: Add 'hovered' to current tease and remove from others
                tease.addEventListener('mouseenter', () => {
                    // Remove 'hovered' class from all teases except the current one
                    container.querySelectorAll('.team-map__member-tease').forEach(el => {
                        if (el !== tease) {
                            el.classList.remove('hovered');
                            // Optionally reset GSAP animation here for all except the current one
                            gsap.to(el, {
                                scale: 0.8,
                                opacity: 0,
                                duration: 0.15,
                                ease: 'power3.out'
                            });
                        }
                    });

                    // Add 'hovered' class to the current tease
                    tease.classList.add('hovered');
                    // Animate in for the current tease
                    gsap.to(tease, {
                        scale: 1,
                        opacity: 1,
                        duration: 0.2,
                        ease: 'power3.out'
                    });
                });

                // Mouse leave: Remove 'hovered' class from the current tease
                tease.addEventListener('mouseleave', () => {
                    tease.classList.remove('hovered');
                    // Animate out for the current tease
                    gsap.to(tease, {
                        scale: 0.8,
                        opacity: 0,
                        duration: 0.15,
                        ease: 'power3.out'
                    });
                });
            });
        }
    }

    animateScroll(images) {

        // Animate the img elements using horizontalLoop utility
        horizontalLoop(images, {
            speed: 0.6,
            paddingRight: 60,
            ease: "none", // Linear easing for continuous animation
            repeat: -1 // Repeat the animation infinitely
        });
    }
}

// Define the custom element for the photo scroller
customElements.define('photo-scroller', PhotoScroller);


class OpiDiagram extends HTMLElement {

    constructor() {
        super();

        // Bind event handlers
        this.onSvgClick = this.onSvgClick.bind(this);
        this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this);
    }

    connectedCallback() {
        // Check if SVG exists before adding event listener
        const svgElement = this.querySelector('svg');
        if (svgElement) {
            svgElement.addEventListener('click', this.onSvgClick);
        } else {
            // console.error('SVG element not found inside OpiDiagram');
        }

        this.mediaQuery = window.matchMedia('(max-width: 1060px)');
        this.mediaQuery.addEventListener('change', this.handleMediaQueryChange);
        this.handleMediaQueryChange(this.mediaQuery); // Call it initially to set the state
    }

    disconnectedCallback() {
        // Check if SVG exists before removing event listener
        const svgElement = this.querySelector('svg');
        if (svgElement) {
            svgElement.removeEventListener('click', this.onSvgClick);
        }

        this.mediaQuery.removeEventListener('change', this.handleMediaQueryChange);
    }

    onSvgClick(event) {
        const className = event.target.getAttribute('class');
        if (className) {
            this.className = className;  // Apply the class to the component
            if (this.mediaQuery.matches) {
                // Scroll to the top of the 'opi-purpose' element if screen width is less than 1060px
                const purposeElement = document.querySelector('.opi-purpose');
                if (purposeElement) {
                    purposeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        }
    }

    handleMediaQueryChange(e) {
        if (e.matches) {
            // console.log('Screen width is less than 1060px');
        } else {
            // console.log('Screen width is 1060px or greater');
        }
    }
}

// Define the custom element
customElements.define('opi-diagram', OpiDiagram);




// A list of functions to run
function init() {
    // console.log('init');
    fitvids();
    initHeadroom();
    initAccordion();
    initMobileMenu();
    initSliders();
    initSubMenu();
    initTeam();
    initAnimations();
    scrollToContent();
    isTouchDevice();
    toggleFunctions();

    preloadImages().then(() => {
       ScrollTrigger.refresh();
    });

};

// Initial load
document.addEventListener('DOMContentLoaded', () => init());


// This event runs for every page view after initial load
swup.hooks.on('page:view', () => {
    init();
})


swup.hooks.on('page:view', () => {



});


